
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title: "Comment créer un compte Instagram Pro, Créateur ou Perso",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Découvrez comment créer un compte Instagram adapté à vos besoins, que vous soyez un professionnel ou un utilisateur personnel, et tirez parti de chaque format.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Comment créer un compte Instagram Pro, Créateur ou Perso",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "L’univers des réseaux sociaux ne cesse de s’étendre, et Instagram brille parmi les plateformes les plus en vogue.",
        },
      ],
    };
  },
};
